const msdwTopContentBar = new Swiper('#msdwTopContentBar', {
  slidesPerView: 1, speed: 500, loop: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: true,
  },
  navigation: {
    nextEl: '#msdwTopContentBar .swiper-button-next',
    prevEl: '#msdwTopContentBar .swiper-button-prev',
  },
});
